import { Config } from "../core/config/config";

export function getCurrencyToConvertIn(isOpenLoop: boolean, foreignCurrency: string | null): string | null {
  if (isOpenLoop) {
    return foreignCurrency;
  }
  return Config.CURRENCY_TO_CONVERT_IN_EUR_ENABLED ? "EUR" : null;
}
